import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/fonts.scss';
import './assets/scss/normalize.scss';
import './assets/scss/body.scss';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);